import { render } from "./BackButton.vue?vue&type=template&id=2bbfc144"
import script from "./BackButton.vue?vue&type=script&lang=js"
export * from "./BackButton.vue?vue&type=script&lang=js"
script.render = render

export default script